import moment from "moment";
import { useDispatch } from "react-redux";
import { fromRruleString } from "../../helpers/rrule";
import { openEventNotificationModel, openParticipantModel, openScheduleEventSendNotificationModel } from "../../store/slices/eventSlice";

const renderSchedule = (attributes) => {
  const getDuration = (value) => {
    if (value == null) {
      return "";
    }
    if (value <= 0) {
      return "";
    }
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    let hour;
    if (hours === 0) {
      hour = "";
    } else if (hours === 1) {
      hour = `${hours} hr `;
    } else {
      hour = `${hours} hrs `;
    }
    const min = minutes > 0 ? `${minutes} mins` : "";
    return (hour + min).trim();
  };

  const rules = fromRruleString(attributes.rrule);

  const startTime = moment(rules.startDate).format('Y-MM-DD hh:mma');
  const startTimeDaily = moment(rules.startDate).format('hh:mma');
  const endTime = moment(rules.startDate).add(attributes.duration, 'minutes').format('hh:mma');

  if (rules.recurring) {
    if (rules.recurringType === "daily") {
      return (
        <>
          <p className="f-11 mb-0">Schedule</p>
          <p className="f-12">
            <strong>
              Daily {startTimeDaily} to {endTime} (
              {getDuration(attributes.duration)})
            </strong>
          </p>
        </>
      );
    }
    if (rules.recurringType === "weekly") {
      return (
        <>
          <p className="f-11 mb-0">Schedule</p>
          <p className="f-12">
            <strong>
              Weekly ({rules.days ? rules.days.join(", ") : "none"}){" "}
              {startTimeDaily} to {endTime} ({getDuration(attributes.duration)})
            </strong>
          </p>
        </>
      );
    }
  }
  if (!rules.recurring) {
    return (
      <>
        <p className="f-11 mb-0">Schedule</p>
        <p className="f-12">
          <strong>
            {startTime} to {endTime} ({getDuration(attributes.duration)})
          </strong>
        </p>
      </>
    );
  }
  return null;
};

const EventCell = ({ event }) => {
    const dispatch = useDispatch();
    const eventData = event.attributes;
    return (
        <div className="poll-cell border">
            <div className="pb-2">
                <div className="top-section">
                    <div className="header-section">
                        <span className="question-heading">{eventData.title}</span>
                        <span className="status">{eventData.description}</span>
                    </div>
                </div>

                <div className="answer-section">
                    <div style={{ fontSize: '12px' }}>

                        {renderSchedule(eventData)}
                        {eventData.hosts.length > 0 &&
                            <>
                                <p className="f-11 mb-0">DJs</p>
                                <p className="f-12"><strong>{eventData.hosts.join(', ')}</strong></p>
                            </>
                        }
                        {eventData.tags.length > 0 &&
                            <>
                                <p className="f-11 mb-0">Tags</p>
                                <p className="f-12"><strong>{eventData.tags.join(', ')}</strong></p>
                            </>
                        }
                    </div>
                </div>
            </div>
            <div className="footer-section">
                <div className="d-flex justify-content-end">
                    <div className="px-1">
                        <button
                            onClick={() => {
                                dispatch(openParticipantModel(event.id))
                            }}
                            disabled={eventData.followers > 0 ? '' : 'disabled'}
                            className="btn btn-sm f-11 btn-primary py-1"
                        >
                            {`Show Followers (${eventData.followers})`}
                        </button>
                    </div>
                    <div className="px-1">
                        <button
                            onClick={() => {
                                dispatch(openEventNotificationModel(event.id))
                            }}
                            disabled={eventData.followers > 0 ? '' : 'disabled'}
                            className="btn btn-dark f-11 px-4"
                        >
                            Send Now
                        </button>
                    </div>
                    <div className="px-1">
                        <button
                            className="btn btn-success f-11 px-4"
                            disabled={eventData.followers > 0 ? '' : 'disabled'}
                            onClick={() => {
                                dispatch(openScheduleEventSendNotificationModel(event))
                            }}
                        >
                            Schedule Send
                        </button>
                    </div>

                </div>
            </div>

        </div>
    )
};


export default EventCell;
